export default __webpack_public_path__ + "static/media/planetm02.64fe11ca.png";